import React, { useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../context/auth.store';
import toast from 'react-hot-toast';

// ── Icons ─────────────────────────────────────────────────────────────────────
const I = {
  Reports:  () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>,
  Shield:   () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>,
  Users:    () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/></svg>,
  Folder:   () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 19a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2h5l2 3h9a2 2 0 012 2z"/></svg>,
  Cloud:    () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 10a5 5 0 00-9.53-1.8 5 5 0 00-6.4 6.3 4 4 0 003.93 3.5h12a5 5 0 005-5A5 5 0 0018 10z"/></svg>,
  Mail:     () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>,
  Send:     () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>,
  Activity: () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>,
  Logout:   () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>,
  Menu:     () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="18" x2="21" y2="18"/></svg>,
  Close:    () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>,
  Dispatch: () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>,
  Table:    () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="18" height="18" rx="1"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="3" y1="15" x2="21" y2="15"/><line x1="9" y1="9" x2="9" y2="21"/><line x1="15" y1="9" x2="15" y2="21"/></svg>,
  Sales:    () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>,
};

const ROLE_COLOR = { ADMIN:'#EA580C', MANAGER:'#1D4ED8', VIEWER:'#15803D', CLIENT:'#7C3AED' };

function NavItem({ to, end, icon, label, onClick }) {
  return (
    <NavLink to={to} end={end}
      className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
      onClick={onClick}>
      {icon} <span>{label}</span>
    </NavLink>
  );
}

function SidebarContent({ isAdmin, user, onLogout, onClose }) {
  const initials = user?.name?.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2) || 'U';
  return (
    <>
      <div className="sidebar-logo" style={{ justifyContent: 'space-between', alignItems: 'center', padding: '16px 14px', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <img
            src="/trendforge_logo.png"
            alt="Trendforge"
            style={{
              width: '36px',
              height: '36px',
              borderRadius: '8px',
              objectFit: 'contain',
              background: '#FFFFFF',
              padding: '2px',
              boxShadow: '0 4px 12px rgba(0, 192, 250, 0.25)',
              flexShrink: 0,
            }}
          />
          <div>
            <div style={{
              fontFamily: "'Orbitron', 'Rajdhani', sans-serif",
              fontWeight: '900',
              fontSize: '13.5px',
              letterSpacing: '0.06em',
              color: '#FFFFFF',
              lineHeight: 1.1,
              whiteSpace: 'nowrap',
            }}>
              PX <span style={{ color: '#00C0FA' }}>REPORTS</span>
            </div>
            <div style={{
              fontFamily: "'Rajdhani', 'Space Grotesk', sans-serif",
              fontSize: '10px',
              fontWeight: '700',
              letterSpacing: '0.06em',
              marginTop: '2px',
              display: 'flex',
              alignItems: 'center',
              gap: '3px',
              whiteSpace: 'nowrap',
            }}>
              <span style={{ color: '#94A3B8' }}>POWERED BY</span>
              <span style={{ color: '#FFFFFF', fontWeight: '800' }}>TREND</span>
              <span style={{ color: '#FF5722', fontWeight: '900' }}>FORGE</span>
            </div>
          </div>
        </div>
        {onClose && (
          <button onClick={onClose}
            style={{ border: 'none', background: 'transparent', cursor: 'pointer', color: 'rgba(255,255,255,0.5)', padding: 4, display: 'flex', alignItems: 'center' }}>
            <I.Close />
          </button>
        )}
      </div>

      {/* Reports section */}
      <div className="nav-section">Operations & Reports</div>
      <NavItem to="/"  end icon={<I.Reports />} label="Dashboard & Overview"  onClick={onClose} />
      <NavItem to="/central-reports" icon={<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>} label="Central Reports (report@kaizen)" onClick={onClose} />
      <NavItem to="/onedrive" icon={<I.Cloud />} label="Operations Explorer" onClick={onClose} />
      <NavItem to="/ai-assistant" icon={<svg viewBox="0 0 24 24" fill="none" stroke="#00C0FA" strokeWidth="2"><circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="4"/><path d="M12 3v3M12 18v3M3 12h3M18 12h3"/></svg>} label="KYRO AI (Offline)" onClick={onClose} />
      
      {isAdmin && (
        <>
          <div className="nav-section" style={{ marginTop: 10 }}>Security & Governance</div>
          <NavItem to="/governance" icon={<I.Shield />} label="Data & Access Control" onClick={onClose} />
          <NavItem to="/user-access" icon={<I.Users />} label="User Access Explorer" onClick={onClose} />
          <NavItem to="/one-pager" icon={<I.Sales />} label="Sales 1-Pager" onClick={onClose} />
        </>
      )}

      {/* Admin section */}
      {isAdmin && (
        <>
          <div className="nav-section" style={{ marginTop: 10 }}>Administration</div>
          <NavItem to="/admin"             end icon={<I.Shield   />} label="Dashboard"        onClick={onClose} />
          <NavItem to="/admin/users"           icon={<I.Users    />} label="Users & Access"   onClick={onClose} />
          <NavItem to="/admin/folder-map"      icon={<I.Folder   />} label="Folder Mapping"   onClick={onClose} />
          <NavItem to="/admin/onedrive"        icon={<I.Cloud    />} label="OneDrive Explorer" onClick={onClose} />
          <NavItem to="/admin/distribution"    icon={<I.Send     />} label="Report Distribution" onClick={onClose} />
          <NavItem to="/admin/email-flows"     icon={<I.Mail     />} label="Email Flows"      onClick={onClose} />
          <NavItem to="/admin/dispatches"      icon={<I.Dispatch />} label="My Dispatches"    onClick={onClose} />
          <NavItem to="/admin/audit"           icon={<I.Activity />} label="Audit Log"        onClick={onClose} />
        </>
      )}

      <div className="sidebar-bottom" style={{ padding: '20px', color: 'rgba(255,255,255,0.4)', fontSize: '12px', textAlign: 'center' }}>
        &copy; {new Date().getFullYear()} PetafluxAI. All rights reserved.
      </div>
    </>
  );
}

export default function Layout() {
  const { user, logout, isAdmin } = useAuthStore();
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = useState(false);
  const admin = isAdmin();

  const handleLogout = async () => {
    await logout();
    toast.success('Signed out');
    navigate('/login');
  };

  const [isCollapsed, setIsCollapsed] = useState(false);
  const showSidebar = ['ADMIN', 'MANAGER'].includes(user?.role);

  return (
    <div className="app-layout">
      {/* Desktop sidebar */}
      {showSidebar && (
        <nav className={`sidebar ${isCollapsed ? 'collapsed' : ''}`}>
          <SidebarContent isAdmin={admin} user={user} onLogout={handleLogout} onClose={null} />
        </nav>
      )}

      {/* Mobile overlay */}
      {mobileOpen && showSidebar && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', zIndex: 998 }}
          onClick={() => setMobileOpen(false)} />
      )}

      {/* Mobile drawer */}
      {showSidebar && (
        <nav className="sidebar mobile-drawer" style={{
          position: 'fixed', top: 0, left: 0, height: '100vh', zIndex: 999,
          transform: mobileOpen ? 'translateX(0)' : 'translateX(-100%)',
          transition: 'transform 0.25s ease',
        }}>
          <SidebarContent isAdmin={admin} user={user} onLogout={handleLogout} onClose={() => setMobileOpen(false)} />
        </nav>
      )}

      {/* Main */}
      <div className="main-content">
        <div className="desktop-topbar" style={{ padding: showSidebar ? '12px 32px' : '16px 40px' }}>
          {showSidebar ? (
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              <button onClick={() => setIsCollapsed(!isCollapsed)} style={{ background: 'transparent', border: 'none', cursor: 'pointer', color: 'var(--text-secondary)' }} title="Toggle Sidebar">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
              </button>
            </div>
          ) : (
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginRight: '24px' }}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#FF7043" strokeWidth="2.5"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
              <span style={{ color: 'var(--text-primary)', fontWeight: 'bold', fontSize: '16px', fontFamily: 'var(--font-display)', letterSpacing: '-0.01em' }}>Reports Vault</span>
            </div>
          )}
          <div id="topbar-portal-target-left" style={{ flex: 1, display: 'flex', alignItems: 'center' }}></div>
          <div id="topbar-portal-target" style={{ display: 'flex', alignItems: 'center', paddingRight: '20px' }}></div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div style={{ textAlign: 'right' }}>
              <div style={{ fontSize: '13px', fontWeight: 'bold', color: 'var(--text-primary)' }}>{user?.name}</div>
              <div style={{ fontSize: '11px', color: 'var(--text-secondary)' }}>{user?.role}</div>
            </div>
            <div className="sidebar-avatar" style={{ background: ROLE_COLOR[user?.role] || '#F97316' }}>
              {user?.name?.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2) || 'U'}
            </div>
            <button onClick={handleLogout} title="Sign out" style={{ border: 'none', borderRadius: '50%', background: 'rgba(238, 93, 80, 0.1)', cursor: 'pointer', color: 'var(--danger)', width: '34px', height: '34px', marginLeft: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.2s' }}>
              <I.Logout />
            </button>
          </div>
        </div>
        <div className="mobile-topbar">
          {showSidebar && <button className="mobile-menu-btn" onClick={() => setMobileOpen(true)}><I.Menu /></button>}
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <img src="/trendforge_logo.png" alt="Trendforge" style={{ width: '24px', height: '24px', borderRadius: '6px', background: '#FFFFFF', padding: '2px' }} />
            <span style={{ color: '#fff', fontWeight: 'bold', fontSize: '13px', fontFamily: "'Orbitron', sans-serif" }}>PX <span style={{ color: '#00C0FA' }}>REPORTS</span></span>
          </div>
          <button onClick={handleLogout} style={{ border: 'none', background: 'transparent', color: 'white', cursor: 'pointer' }}><I.Logout /></button>
        </div>
        <Outlet />
      </div>
    </div>
  );
}
